<template>
    <div style="max-width: 770px;" id="processing">
        <div v-if="errorMessage">
            <div class="alert alert-danger w-100 mt-4">
                There was an error submitting your application. Please click below to try again.
            </div>
            <button class="btn btn-cta btn-red uc" @click="resubmit" :disabled="saving" id="form-resubmit">{{saving ? 'Sending Your Request...' : 'Try Again'}}</button>
        </div>
        <div v-else>
            <div class="progress" style="height: 20px;">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{width: progress + '%'}">Searching...</div>
            </div>
            <div class="mt-4 text-left">
                Please wait while we search our network of lenders. This process may take up to 5-8 minutes.<br><br><strong>DO NOT</strong> close your browser, refresh the page or press the back button as this will interfere with your submission.
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Sending',
    title: 'Apply | Sending',
    components:{
    },
    data() {
	  return {
          progress: 0,
          errorMessage: false,
          saving: false,
	  }
    },
    methods: {
        setProgress(){
            let progress = this.progress;
            switch(true){
                case (progress < 50):
                    this.progress += Math.floor(Math.random() * 7) + 3;
                break;
                case (progress < 90):
                    this.progress += Math.floor(Math.random() * 4) + 2;
                break;
                case (progress < 97):
                    this.progress += 2;
                break;
                default:
                    this.progress = 99;
            }
        },
        submitData(){
            this.progress = 99;
            this.$router.push({ path: '/thankyou' });
            return;
        }
    },
    watch: {
    },
    computed: {
    },
    created(){
        setTimeout(this.setProgress, 1000);
        setInterval(this.setProgress, 2000);
        setTimeout(this.submitData, 10000);
  }
}
</script>

<style>
    
</style>
